import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { Eye, EyeOff } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Conta criada!");
      nav("/conta");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-10 sm:py-16">
      <h1 className="text-3xl font-bold text-center" style={{ fontFamily: "Outfit" }}>Criar conta</h1>
      <form onSubmit={submit} className="mt-8 space-y-4 bg-white border rounded-xl p-6">
        <div><Label>Nome</Label><Input data-testid="reg-name" value={form.name} onChange={(e) => set("name", e.target.value)} required /></div>
        <div><Label>E-mail</Label><Input data-testid="reg-email" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} required /></div>
        <div><Label>Telefone (opcional)</Label><Input data-testid="reg-phone" value={form.phone} onChange={(e) => set("phone", e.target.value)} /></div>
        <div>
          <Label>Senha</Label>
          <div className="relative">
            <Input
              data-testid="reg-password"
              type={showPwd ? "text" : "password"}
              minLength={6}
              value={form.password}
              onChange={(e) => set("password", e.target.value)}
              required
              className="pr-10"
            />
            <button
              type="button"
              onClick={() => setShowPwd((v) => !v)}
              data-testid="reg-toggle-password"
              aria-label={showPwd ? "Ocultar senha" : "Mostrar senha"}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-neutral-500 hover:text-neutral-900 p-1"
            >
              {showPwd ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
        </div>
        <Button data-testid="reg-submit" type="submit" disabled={loading} className="w-full bg-[#C91F1F] hover:bg-[#9F1515] h-11">
          {loading ? "Criando..." : "Criar conta"}
        </Button>
        <p className="text-sm text-center text-neutral-600">
          Já tem conta? <Link to="/entrar" className="text-[#C91F1F] font-semibold">Entrar</Link>
        </p>
      </form>
    </div>
  );
}
